import "./path0.0c59f5a0.js";


      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3093"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3093"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;







var $7CJkj = parcelRequire("7CJkj");

var $dB6Iv = parcelRequire("dB6Iv");

var $1n4Kt = parcelRequire("1n4Kt");

var $8ucNL = parcelRequire("8ucNL");

var $gaesL = parcelRequire("gaesL");

var $aE8qp = parcelRequire("aE8qp");
// Which legal page this URL is: a public slug in either language, a
// prerendered file name, or `?page=` on the dev server, which has no rewrites.
const $4fa31efd42b2f888$var$getPage = ()=>{
    const params = new URLSearchParams(window.location.search);
    const pageParam = params.get('page');
    if (pageParam && (0, $8ucNL.LEGAL_PAGES)[pageParam]) return pageParam;
    return (0, $8ucNL.legalPageFromPath)(window.location.pathname) || 'impressum';
};
const $4fa31efd42b2f888$var$replaceMicrocopy = (microcopy)=>{
    (0, $dB6Iv.getMicrocopySlots)().forEach((slot)=>{
        const value = microcopy[slot.id];
        if (!value) {
            console.error(`No microcopy found for "${slot.id}"`);
            return;
        }
        slot.innerHTML = (0, $7CJkj.parseRichText)(value);
    });
};
const $4fa31efd42b2f888$var$setMeta = (key, value)=>{
    const el = document.querySelector(`meta[${key}]`);
    if (el) el.setAttribute('content', value);
};
const $4fa31efd42b2f888$var$initPage = ({ microcopy: microcopy, locale: locale })=>{
    const page = $4fa31efd42b2f888$var$getPage();
    const pageConfig = (0, $8ucNL.LEGAL_PAGES)[page];
    const title = microcopy[pageConfig.titleKey];
    const content = microcopy[pageConfig.contentKey];
    if (!title || !content) {
        console.error(`Missing content for legal page: ${page}`);
        window.location.replace('/');
        return;
    }
    const titleText = (0, $gaesL.documentToPlainTextString)(title);
    document.getElementById('page-title').textContent = titleText;
    document.getElementById('page-content').innerHTML = (0, $7CJkj.parseRichText)(content);
    document.title = `${titleText} | HINTERLAND software`;
    $4fa31efd42b2f888$var$setMeta('property="og:title"', `${titleText} | HINTERLAND software`);
    $4fa31efd42b2f888$var$setMeta('property="og:url"', window.location.href.split('?')[0]);
    const description = (0, $gaesL.documentToPlainTextString)(content).slice(0, 160);
    $4fa31efd42b2f888$var$setMeta('property="og:description"', description);
    $4fa31efd42b2f888$var$setMeta('name="description"', description);
    document.documentElement.lang = (0, $1n4Kt.getLanguageCode)(locale);
    $4fa31efd42b2f888$var$replaceMicrocopy(microcopy);
    (0, $dB6Iv.localizeLegalLinks)((0, $1n4Kt.getLanguageCode)(locale));
    document.getElementById('year').textContent = new Date().getFullYear();
    document.querySelector('div.loading-screen').classList.add('hidden');
    document.documentElement.classList.remove('no-js');
    (0, $aE8qp.default)((0, $1n4Kt.getLanguageCode)(locale));
};
const $4fa31efd42b2f888$var$init = ()=>{
    const { locale: locale, redirectTo: redirectTo } = (0, $1n4Kt.resolveLocale)();
    if (redirectTo) {
        window.location.replace(redirectTo);
        return new Promise(()=>{});
    }
    document.documentElement.lang = (0, $1n4Kt.getLanguageCode)(locale);
    return (0, $7CJkj.fetchMicrocopyOnly)(locale).then((microcopy)=>({
            microcopy: microcopy,
            locale: locale
        })).then($4fa31efd42b2f888$var$initPage);
};
try {
    (0, $dB6Iv.useDarkMode)();
    $4fa31efd42b2f888$var$init().catch((0, $dB6Iv.onError));
} catch (error) {
    (0, $dB6Iv.onError)(error);
}


//# sourceMappingURL=legal.617ac1b7.js.map
